import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { cleanMsg, useConvocatoria } from '../../../appStore/convocatoria';
import { ESTADOS_CONVOCATORIA } from '../../../const';
import { useConcurso } from '../../../providers/ConcursoProvider';
import FullLoading from '../../CompUtils/FullLoading';
import { SuccessErrorDlg } from '../../CompUtils/SuccessErrorDlg';
import { finEtapa } from '../Gestion/gestionConcursoSlice';
import AccionesAmpliacionDocumentalCC from './AccionesAmpliacionDocumentalCC';
import AccionesConvocatoriaPublicadaCC from './AccionesConvocatoriaPublicadaCC';
import AccionesEvaluacionAntecedentesCC from './AccionesEvaluacionAntecedentesCC';
import AccionesEvaluacionInicialCC from './AccionesEvaluacionInicialCC';
import AccionesEvaluacionLaboralCC from './AccionesEvaluacionLaboralCC';
import AccionesEvaluacionPsicologicaCC from './AccionesEvaluacionPsicologicaCC';
import AccionesEvaluacionTecnicaGeneralCC from './AccionesEvaluacionTecnicaGeneralCC';
import AccionesEvaluacionTecnicaSustantivaCC from './AccionesEvaluacionTecnicaSustantivaCC';
import AccionesInscripcionWebCC from './AccionesInscripcionWebCC';
import AccionesOrdenDeMeritoCC from './AccionesOrdenDeMeritoCC';
import AccionesPublicacionConvocatoriaCC from './AccionesPublicacionConvocatoriaCC';
import AccionesValidacionDocumentalCC from './AccionesValidacionDocumentalCC';
import AccionesValidacionPosPeriodoAmpliacionDocumentalCC from './AccionesValidacionPosPeriodoAmpliacionDocumentalCC';
import { cleanMsgAccion, useAccionesConcurso } from './restAccionesConcurso';

export const AccionesConcurso = () => {
  const dispatch = useDispatch();
  const concurso = useConcurso();
  const history = useHistory();
  const { error, success } = useConvocatoria();
  const { etapaLlamadoConcurso } = useConcurso();
  const { idEtapaLlamadoConcurso } = etapaLlamadoConcurso;
  const { esCoordinadorConcursal } = concurso;
  const { finishedAccion, errorAccion, successAccion, loadingAccion } = useAccionesConcurso();

  return esCoordinadorConcursal ? (
    <>
      <h2 className="d-flex justify-content-center text-info">Acciones</h2>
      {finishedAccion && (
        <SuccessErrorDlg
          error={errorAccion}
          success={successAccion}
          onClose={() => {
            dispatch(cleanMsgAccion());
            dispatch(finEtapa());
            history.replace('/concursos');
          }}
        />
      )}
      <FullLoading show={loadingAccion} />

      {/* --------------------ACCIONES COORDINADOR CONCURSAL-------------------- */}

      {esCoordinadorConcursal && (
        <>
          {/* 7 - PUBLICACION CONVOCATORIA */}
          {idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.PUBLICACION_CONVOCATORIA && (
            <AccionesPublicacionConvocatoriaCC />
          )}

          {/* 8 - CONVOCATORIA_PUBLICADA */}
          {idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.CONVOCATORIA_PUBLICADA && (
            <AccionesConvocatoriaPublicadaCC />
          )}

          {/* 9 - INSCRIPCION_WEB */}
          {idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.INSCRIPCION_WEB && (
            <AccionesInscripcionWebCC />
          )}

          {/* 10 - EVALUACION_INICIAL */}
          {idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.EVALUACION_INICIAL && (
            <AccionesEvaluacionInicialCC />
          )}

          {/* 11 - VALIDACION_DOCUMENTAL */}
          {idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.VALIDACION_DOCUMENTAL && (
            <AccionesValidacionDocumentalCC />
          )}

          {/* 12 - AMPLIACION_DOCUMENTAL */}
          {idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.AMPLIACION_DOCUMENTAL && (
            <AccionesAmpliacionDocumentalCC />
          )}

          {/* 13 - VALIDACION_POS_PERIODO_AMPLIACION_DOCUMENTAL */}
          {idEtapaLlamadoConcurso ===
            ESTADOS_CONVOCATORIA.VALIDACION_POS_PERIODO_AMPLIACION_DOCUMENTAL && (
            <AccionesValidacionPosPeriodoAmpliacionDocumentalCC />
          )}

          {/* 14 - EVALUACION_ANTECEDENTES */}
          {idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.EVALUACION_ANTECEDENTES && (
            <AccionesEvaluacionAntecedentesCC />
          )}

          {/* 15 - EVALUACION_TECNICA_GENERAL */}
          {idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.EVALUACION_TECNICA_GENERAL && (
            <AccionesEvaluacionTecnicaGeneralCC />
          )}

          {/* 16 - EVALUACION_TECNICA_SUSTANTIVA */}
          {idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.EVALUACION_TECNICA_SUSTANTIVA && (
            <AccionesEvaluacionTecnicaSustantivaCC />
          )}

          {/* 17 - EVALUACION_LABORAL */}
          {idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.EVALUACION_LABORAL && (
            <AccionesEvaluacionLaboralCC />
          )}

          {/* 18 - EVALUACION_PSICOLOGICA */}
          {idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.EVALUACION_PSICOLOGICA && (
            <AccionesEvaluacionPsicologicaCC />
          )}

          {/* 19 - ORDEN_DE_MERITO */}
          {idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.ORDEN_DE_MERITO && (
            <AccionesOrdenDeMeritoCC />
          )}

          {/* 20 - CONCURSO_FINALIZADO */}
          {idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.CONCURSO_FINALIZADO && <></>}
        </>
      )}

      {/* 
      {esCoordinadorConcursal &&
        idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.PUBLICACION_CONVOCATORIA && (
          <AccionesPublicacionConvocatoriaCC />
        )}

      {esCoordinadorConcursal &&
        idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.CONVOCATORIA_PUBLICADA && (
          <AccionesConvocatoriaPublicadaCC />
        )}

      {esCoordinadorConcursal &&
        idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.INSCRIPCION_WEB && (
          <AccionesInscripcionWebCC />
        )}

      {esCoordinadorConcursal &&
        idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.EVALUACION_INICIAL && (
          <AccionesEvaluacionInicialCC />
        )}

      {esCoordinadorConcursal &&
        idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.VALIDACION_DOCUMENTAL && (
          <AccionesValidacionDocumentalCC />
        )}

      {esCoordinadorConcursal &&
        idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.EVALUACION_ANTECEDENTES_CURRICULARES && (
          <h3>EVALUACION ANTECEDENTES CURRICULARES</h3>
        )}

      {esCoordinadorConcursal &&
        idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.EVALUACION_TECNICA_GENERAL && (
          <h3>EVALUACION TECNICA GENERAL</h3>
        )}

      {esCoordinadorConcursal &&
        idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.EVALUACION_TECNICA_SUSTANTIVA && (
          <h3>EVALUACION TECNICA SUSTANTIVA</h3>
        )}

      {esCoordinadorConcursal &&
        idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.ENTREVISTA_LABORAL && (
          <h3>ENTREVISTA LABORAL</h3>
        )}

      {esCoordinadorConcursal &&
        idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.ORDEN_DE_MERITO && <h3>ORDEN DE MERITO</h3>}

      {esCoordinadorConcursal &&
        idEtapaLlamadoConcurso === ESTADOS_CONVOCATORIA.CONCURSO_FINALIZADO && (
          <h3>CONCURSO FINALIZADO</h3>
        )} 
*/}
      {/* --------------------ACCIONES COORDINADOR CONCURSAL-------------------- */}

      <SuccessErrorDlg
        error={error}
        success={success}
        onClose={() => {
          dispatch(cleanMsg());
          if (success) {
            dispatch(finEtapa());
            history.replace('/concursos');
          }
        }}
      />
    </>
  ) : (
    <h2 className="d-flex justify-content-center text-info">
      No posees acciones para realizar aqui
    </h2>
  );
};
